import type { IInputQuestion } from './_question';
import type { IDateInputProps } from '../Inputs/MonthYearInput';

import React from 'react';
import { Controller } from 'react-hook-form';

import MonthYearInput from '../Inputs/MonthYearInput';

import InputWrapper from './elements/InputWrapper';
import Subtitle from './elements/Subtitle';
import Title from './elements/Title';

import getControlError from '$/hooks/getControlError';
import isDateValid from '$/utils/isDateValid';

export interface IDateInputQuestion
  extends IInputQuestion,
    Omit<IDateInputProps, 'selected' | 'onChange' | 'value'> {
  onValueSelected?: () => void;
}

const MonthYearInputQuestion = ({
  control,
  name,
  onValueSelected,
  title,
  subTitle,
  setError,
  ...props
}: IDateInputQuestion) => (
  <InputWrapper>
    {title && <Title>{title}</Title>}
    {subTitle && <Subtitle>{subTitle}</Subtitle>}
    <Controller
      control={control}
      name={name}
      defaultValue={''}
      render={({ field, fieldState }) => {
        const error = getControlError(control, name, props.errorMessage);
        const onChange = (data: Date) => {
          if (isNaN(data.getTime()) && setError) {
            setError(name, { message: 'Falsches Datum' });
          }

          if (isDateValid(data)) {
            field.onChange(data);
            if (onValueSelected) {
              onValueSelected();
            }
          }
        };

        return (
          <MonthYearInput
            {...field}
            {...fieldState}
            error={fieldState.invalid}
            onChange={onChange}
            {...props}
            errorMessage={error.message}
          />
        );
      }}
    />
  </InputWrapper>
);

export default MonthYearInputQuestion;
